export const messages = {
  en: {
    feePrintSpecManage: {
      title: 'Print Configuration',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      image: 'Image',
      name: 'Name',
      spec: 'Specification',
      code: 'Code',
      operation: 'Operation',
      reminderPrint: 'Reminder Print',
      receiptPrint: 'Receipt Print',
      addTitle: 'Add Print Configuration',
      editTitle: 'Edit Print Configuration',
      deleteTitle: 'Delete Confirmation',
      deleteConfirm: 'Are you sure to delete this print configuration?',
      deleteSuccess: 'Delete successfully',
      deleteFailed: 'Delete failed',
      addSuccess: 'Add successfully',
      addFailed: 'Add failed',
      editSuccess: 'Edit successfully',
      editFailed: 'Edit failed',
      fetchError: 'Failed to fetch data',
      specPlaceholder: 'Please select specification',
      namePlaceholder: 'Please enter name',
      contentPlaceholder: 'Optional, please enter content',
      specRequired: 'Specification is required',
      nameRequired: 'Name is required',
      nameMaxLength: 'Name cannot exceed 128 characters',
      content: 'Content'
    }
  },
  zh: {
    feePrintSpecManage: {
      title: '打印配置信息',
      add: '添加',
      edit: '修改',
      delete: '删除',
      image: '图片',
      name: '名称',
      spec: '规格',
      code: '编码',
      operation: '操作',
      reminderPrint: '催缴打印说明',
      receiptPrint: '收据打印说明',
      addTitle: '添加打印配置',
      editTitle: '修改打印配置',
      deleteTitle: '删除确认',
      deleteConfirm: '确定删除打印配置吗？',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      addSuccess: '添加成功',
      addFailed: '添加失败',
      editSuccess: '修改成功',
      editFailed: '修改失败',
      fetchError: '获取数据失败',
      specPlaceholder: '请选择规格',
      namePlaceholder: '请输入名称',
      contentPlaceholder: '选填，请输入内容',
      specRequired: '规格不能为空',
      nameRequired: '名称不能为空',
      nameMaxLength: '名称不能超过128个字符',
content: '内容'
    }
  },
  'zh-TW': {
    feePrintSpecManage: {
      title: '列印配置信息',
      add: '添加',
      edit: '修改',
      delete: '刪除',
      image: '圖片',
      name: '名稱',
      spec: '規格',
      code: '編碼',
      operation: '操作',
      reminderPrint: '催繳列印說明',
      receiptPrint: '收據列印說明',
      addTitle: '添加列印配置',
      editTitle: '修改列印配置',
      deleteTitle: '刪除確認',
      deleteConfirm: '確定刪除列印配置嗎？',
      deleteSuccess: '刪除成功',
      deleteFailed: '刪除失敗',
      addSuccess: '添加成功',
      addFailed: '添加失敗',
      editSuccess: '修改成功',
      editFailed: '修改失敗',
      fetchError: '獲取數據失敗',
      specPlaceholder: '請選擇規格',
      namePlaceholder: '請輸入名稱',
      contentPlaceholder: '選填，請輸入內容',
      specRequired: '規格不能為空',
      nameRequired: '名稱不能為空',
      nameMaxLength: '名稱不能超過128個字符',
      content: '內容'
    }
  }
}